import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GUTTOR_SPACE, IHX_LOGO } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { RootState } from '../../../store';
import { selectSubModule, setCurrentLevel, setSelectedModule } from '../../../store/actions/blogsAction';
import { BlogsInitialState } from '../../../store/models/blogsModel';
import './blogs.less';
import BlogsResult from './BlogsResult';

const Blogs = (): ReactElement => {
  const baseUrl = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}`;
  const { articleList } = useSelector((state: RootState): BlogsInitialState => state?.blogs || {});
  const dispatch = useDispatch();
  const searchInArticles = (ev: any): any => {
    const searchString = ev?.target?.value;
    const selectedArticle = (articleList || [])?.find((ele: any): boolean =>
      ele?.articles?.toLowerCase().includes(searchString.toLowerCase()));
    if (selectedArticle) {
      dispatch(setSelectedModule(selectedArticle?.module));
      dispatch(selectSubModule(selectedArticle?.subModule));
      dispatch(setCurrentLevel(2));
    }
  };

  return (
    <>
      <iframe
        // src="https://newaccount1623851112094.freshdesk.com/support/home" // commenting for now
        src="https://newaccount1623851112094.freshdesk.com/support/solutions/folders/82000696525"
        className={'iframe'}
      />
      {false && (
        <div className="blog-container">
          <div className="header-container">
            <img
              className="header-img"
              src={baseUrl + 'blogs-resources/blogs_header.png'}
             alt={''}/>
            <div className="header-content">
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24}>
                  <img src={IHX_LOGO} className="ihx-logo"  alt={''}/>
                </Col>
              </Row>
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24} className="text-light mt-sm">
                  <strong>
                    DRIVING DIGITAL REVOLUTION IN INDIAN HEALTHCARE
                  </strong>
                </Col>
              </Row>
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24} className="text-light mt-md fsize_sm">
                  <span>Advice and Answers from the IHX Team</span>
                </Col>
              </Row>
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24} className="mt-sm">
                  <Input
                    suffix={<SearchOutlined />}
                    placeholder="Search for articles..."
                    className="custom-input"
                    onPressEnter={searchInArticles}
                    allowClear={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="search-result">
            <BlogsResult />
          </div>
        </div>
      )}
    </>
  );
};
export default Blogs;
